export const wenzhang = [
  {
    id: 1,
    name: '协会公告',
    EnName: 'Announcement',
    path: '/notice?type=1',
    isClick: false,
    children: [
      {
        id: 11,
        name: '赛事活动',
        EnName: 'Match events',
        path: '/notice?type=1-11'
      },
      {
        id: 12,
        name: '赛程公告',
        EnName: 'Schedule',
        path: '/notice?type=1-12'
      },
      {
        id: 13,
        name: '活动信息',
        EnName: 'Notification',
        path: '/notice?type=1-13'
      }
    ]
  },
  {
    id: 2,
    name: '新闻资讯',
    EnName: 'News',
    path: '/news?type=2',
    isClick: false,
    children: [
      {
        id: 21,
        name: '排球动态',
        EnName: 'Volleyball dynamic',
        path: '/news?type=2-21'
      },
      {
        id: 22,
        name: '赛事新闻',
        EnName: 'Match News',
        path: '/news?type=2-22'
      },
      {
        id: 23,
        name: '精彩集锦',
        EnName: 'Highlights',
        path: '/news?type=2-23'
      }
    ]
  }
]

export const singlePages = [
  {
    id: 3,
    name: '排球俱乐部',
    EnName: 'Volleyball CLUB',
    path: '/',
    isClick: false,
    children: [
    ]
  },
  {
    id: 4,
    name: '大众排球',
    EnName: 'The mass volleyball',
    path: '/volleyball?type=41',
    isClick: false,
    children: [
      {
        id: 411,
        name: '气排球',
        EnName: 'Gas volleyball',
        path: '/volleyball?type=41-411'
      },
      {
        id: 412,
        name: '校园排球',
        EnName: 'Campus volleyball',
        path: '/volleyball?type=41-412'
      }
    ]
  },
  {
    id: 5,
    name: '会员专区',
    EnName: 'Member of the zone',
    path: '/userinfo',
    isClick: false,
    children: [
      {
        name: '注册/登录',
        EnName: 'Registration/Sign in',
        path: '/login'
      },
      {
        id: 51,
        name: '会员指南',
        EnName: 'The member guide',
        path: '/member?type=5-51'
      }
    ]
  },
  {
    id: 6,
    name: '关于我们',
    EnName: 'About Us',
    path: '/about?type=6-61',
    isClick: false,
    children: [
      {
        id: 61,
        name: '协会介绍',
        EnName: 'Introduction',
        path: '/about?type=6-61'
      },
      {
        id: 62,
        name: '协会信息',
        EnName: 'Communist House',
        path: '/communist-house?type=62-621',
      },
      {
        id: 63,
        name: '支持单位',
        EnName: 'Support unit',
        path: '/about?type=6-63'
      },
      // {
      //   id: 64,
      //   name: '联系方式',
      //   EnName: 'Contact us',
      //   path: '/about?type=6-64'
      // },
      {
        id: 7,
        name: '下载专区',
        EnName: 'Downloads',
        path: '/download'
      }
    ]
  }
]
